import React, { createContext, useContext, useState, useEffect } from "react";

const VipAccountContext = createContext();

export const VipAccountProvider = ({ children }) => {
  const [vipAccount, setVipAccountState] = useState(() => {
    try {
      const stored = sessionStorage.getItem("vip-account");
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  });

  const setVipAccount = (data) => {
    if (data === null || data === undefined) {
      sessionStorage.removeItem("vip-account");
      localStorage.removeItem("vip-account");
      setVipAccountState(null);
    } else {
      sessionStorage.setItem("vip-account", JSON.stringify(data));
      localStorage.setItem("vip-account", JSON.stringify(data));
      setVipAccountState(data);
    }
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "vip-account") {
        if (e.newValue) {
          try {
            setVipAccountState(JSON.parse(e.newValue));
          } catch (error) {
            setVipAccountState(null);
          }
        } else {
          setVipAccountState(null);
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <VipAccountContext.Provider value={{ vipAccount, setVipAccount }}>
      {children}
    </VipAccountContext.Provider>
  );
};

export const useVipAccountCache = () => {
  const context = useContext(VipAccountContext);
  if (!context) {
    throw new Error(
      "useVipAccountCache must be used within VipAccountProvider",
    );
  }
  return context;
};
